import { Team } from './team';
import { Preference } from './preference';

export class User {
  public UserFirstName = '';
  public UserLastName = '';
  public UserEmail = '';
  public UserPassword = '';
  public UserBirthDate = '';
  public UserPhoneNumber = '';
  public UserFavouriteTeam: Team = new Team();
  public UserPreferences: Preference[] = [];

  constructor() { }

  public static parse(data: any): User {
    const user = new User();

    if (data) {
      if (data.UserFirstName || data.UsuarioNombre) {
        user.UserFirstName = data.UserFirstName || data.UsuarioNombre;
      }
      if (data.UserLastName || data.UsuarioApellido) {
        user.UserLastName = data.UserLastName || data.UsuarioApellido;
      }
      if (data.UserEmail || data.UsuarioEmail) {
        user.UserEmail = data.UserEmail || data.UsuarioEmail;
      }
      if (data.UserPassword || data.UsuarioPassword) {
        user.UserPassword = data.UserPassword || data.UsuarioPassword;
      }
      if (data.UserBirthDate || data.UsuarioFechaNacimiento) {
        user.UserBirthDate = data.UserBirthDate || data.UsuarioFechaNacimiento;
      }
      if (data.UserPhoneNumber || data.UsuarioTelefono) {
        user.UserPhoneNumber = data.UserPhoneNumber || data.UsuarioTelefono;
      }
      const userFavouriteTeamData = {
        TeamId: '',
        TeamName: ''
      };
      // tslint:disable-next-line:max-line-length
      if (data.UsuarioEquipoFavoritoId || (data.UserFavouriteTeam && data.UserFavouriteTeam.TeamId && data.UserFavouriteTeam.TeamId !== '0')) {
        userFavouriteTeamData.TeamId = data.UsuarioEquipoFavoritoId || data.UserFavouriteTeam.TeamId;
      }
      if (data.UsuarioEquipoFavoritoNombre || (data.UserFavouriteTeam && data.UserFavouriteTeam.TeamName)) {
        userFavouriteTeamData.TeamName = data.UsuarioEquipoFavoritoNombre || data.UserFavouriteTeam.TeamName;
      }
      if (userFavouriteTeamData.TeamId) {
        user.UserFavouriteTeam = Team.parse(userFavouriteTeamData);
      }
      if (data.Preferencias && data.Preferencias.length > 0) {
        data.Preferencias.forEach(p => {
          p.PreferenceIsSelected = true;
          user.UserPreferences.push(Preference.parse(p));
        });
      } else if (data.UserPreferences && data.UserPreferences.length > 0) {
        data.UserPreferences.forEach(p => {
          p.PreferenceIsSelected = true;
          user.UserPreferences.push(Preference.parse(p));
        });
      }
    }

    return user;
  }

  public convertUserToBackendFormat(): any {
    const backendUser = {
      UsuarioNombre: null,
      UsuarioApellido: null,
      UsuarioEmail: null,
      UsuarioPassword: null,
      UsuarioFechaNacimiento: null,
      UsuarioTelefono: null,
      UsuarioEquipoFavoritoId: null,
      Preferencias: []
    };

    if (this.UserFirstName) {
      backendUser.UsuarioNombre = this.UserFirstName;
    } else {
      delete backendUser.UsuarioNombre;
    }
    if (this.UserLastName) {
      backendUser.UsuarioApellido = this.UserLastName;
    } else {
      delete backendUser.UsuarioApellido;
    }
    if (this.UserEmail) {
      backendUser.UsuarioEmail = this.UserEmail;
    } else {
      delete backendUser.UsuarioEmail;
    }
    if (this.UserPassword) {
      backendUser.UsuarioPassword = this.UserPassword;
    } else {
      delete backendUser.UsuarioPassword;
    }
    if (this.UserBirthDate) {
      backendUser.UsuarioFechaNacimiento = this.UserBirthDate;
    } else {
      delete backendUser.UsuarioFechaNacimiento;
    }
    if (this.UserPhoneNumber) {
      backendUser.UsuarioTelefono = this.UserPhoneNumber;
    } else {
      delete backendUser.UsuarioTelefono;
    }
    if (this.UserFavouriteTeam && this.UserFavouriteTeam.TeamId) {
      backendUser.UsuarioEquipoFavoritoId = this.UserFavouriteTeam.TeamId;
    } else {
      delete backendUser.UsuarioEquipoFavoritoId;
    }
    // Me quedo únicamente con las preferencias que estén seleccionadas
    if (this.UserPreferences && this.UserPreferences.length > 0) {
      this.UserPreferences = this.UserPreferences.filter(up => up.PreferenceIsSelected);
    }
    if (this.UserPreferences && this.UserPreferences.length > 0) {
      this.UserPreferences.forEach(up => backendUser.Preferencias.push({PreferenciaId: up.PreferenceId}));
    } else {
      delete backendUser.Preferencias;
    }

    return backendUser;
  }
}
